module.exports = __webpack_public_path__ + "static/img/patrowlhears-hero-vuln.038af828.png";